// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 - 调用 /api/v1/auth/user/profile 接口 */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.CurrentUser;
    request_id?: string;
  }>('/api/v1/auth/user/profile', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST https://acz.aigcempower.com//v1/auth/oidc/logout */
export async function outLogin(options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.CurrentUser;
    request_id?: string;
  }>('https://acz.aigcempower.com//v1/auth/oidc/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 重置用户密码接口 POST /api/v1/auth/user/${userId}/reset-password */
export async function resetUserPassword(
  userId: string,
  body: {
    password: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.CurrentUser;
    request_id?: string;
  }>(`/api/v1/auth/user/${userId}/reset-password`, {
    method: 'POST',
    data: {
      password: body.password,
    },
    ...(options || {}),
  });
}

/** 登录接口 POST /api/v1/auth/login */
export async function login(body: { username: string; password: string }, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/v1/auth/login', {
    method: 'POST',
    data: {
      username: body.username,
      password: body.password,
    },
    ...(options || {}),
  });
}

/** 创建用户接口 POST /api/v1/auth/user/create */
export async function createUser(
  body: {
    name: string;
    username: string;
    password: string;
    mobile?: string;
    role: string;
    is_staff?: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.CurrentUser;
    request_id?: string;
  }>('/api/v1/auth/user/create', {
    method: 'POST',
    data: {
      name: body.name,
      username: body.username,
      password: body.password,
      mobile: body.mobile,
      role: body.role,
      is_staff: body.is_staff,
    },
    ...(options || {}),
  });
}

/** 修改用户接口 POST /api/v1/auth/user/${userId}/update */
export async function updateUser(
  userId: string,
  body: {
    name?: string;
    username?: string;
    mobile?: string;
    role?: string;
    is_active?: boolean;
    is_staff?: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.CurrentUser;
    request_id?: string;
  }>(`/api/v1/auth/user/${userId}/update`, {
    method: 'POST',
    data: {
      name: body.name,
      username: body.username,
      mobile: body.mobile,
      role: body.role,
      is_active: body.is_active,
      is_staff: body.is_staff,
    },
    ...(options || {}),
  });
}

/** 获取公司介绍接口 GET /api/v1/content/company/get/aigcempower */
export async function getCompanyInfo(options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: {
      id: string;
      name: string;
      introduction: string;
      sign: string;
      created_at: string;
      updated_at: string;
    };
    request_id?: string;
  }>('/api/v1/content/company/get/aigcempower', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 更新公司介绍接口 POST /api/v1/content/company/${companyId}/update */
export async function updateCompanyInfo(
  companyId: string,
  body: {
    name?: string;
    introduction?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: {
      id: string;
      name: string;
      introduction: string;
      sign: string;
      created_at: string;
      updated_at: string;
    };
    request_id?: string;
  }>(`/api/v1/content/company/${companyId}/update`, {
    method: 'POST',
    data: {
      name: body.name,
      introduction: body.introduction,
    },
    ...(options || {}),
  });
}

/** 创建核心团队成员接口 POST /api/v1/content/company/member/create */
export async function createTeamMember(
  body: {
    name: string;
    position: string;
    introduction: string;
    avatar?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: {
      id: string;
      name: string;
      position: string;
      introduction: string;
      is_active: boolean;
      avatar: string;
      created_at: string;
      updated_at: string;
    };
    request_id?: string;
  }>('/api/v1/content/company/member/create', {
    method: 'POST',
    data: {
      name: body.name,
      position: body.position,
      introduction: body.introduction,
      avatar: body.avatar,
    },
    ...(options || {}),
  });
}

/** 修改核心团队成员接口 POST /api/v1/content/company/member/${memberId}/update */
export async function updateTeamMember(
  memberId: string,
  body: {
    name?: string;
    position?: string;
    introduction?: string;
    avatar?: string;
    is_active?: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.TeamMember;
    request_id?: string;
  }>(`/api/v1/content/company/member/${memberId}/update`, {
    method: 'POST',
    data: {
      name: body.name,
      position: body.position,
      introduction: body.introduction,
      avatar: body.avatar,
      is_active: body.is_active,
    },
    ...(options || {}),
  });
}

/** 删除核心团队成员接口 POST /api/v1/content/company/member/${memberId}/delete */
export async function deleteTeamMember(
  memberId: string,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.TeamMember;
    request_id?: string;
  }>(`/api/v1/content/company/member/${memberId}/delete`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取核心成员列表接口 GET /api/v1/content/company/member/list */
export async function getTeamMemberList(
  params: {
    search?: string;
    is_active?: boolean;
    sort_by?: string;
    page?: number;
    page_size?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.TeamMemberListResult>('/api/v1/content/company/member/admin/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取用户列表接口 GET /api/v1/auth/user/list */
export async function getUserList(
  params: {
    search?: string;
    is_superuser?: boolean;
    is_active?: boolean;
    role?: string;
    sort_by?: string;
    page?: number;
    page_size?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.UserListResult>('/api/v1/auth/user/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取媒体文件列表接口 GET /api/v1/content/company/media/admin/list */
export async function getMediaList(
  params: API.MediaListParams,
  options?: { [key: string]: any },
) {
  return request<API.MediaListResult>('/api/v1/content/company/media/admin/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建视频接口 POST /api/v1/content/company/media/video/create */
export async function createVideo(
  body: {
    path: string;
    description?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.MediaItem;
    request_id?: string;
  }>('/api/v1/content/company/media/video/create', {
    method: 'POST',
    data: {
      path: body.path,
      description: body.description,
    },
    ...(options || {}),
  });
}

/** 创建轮播图接口 POST /api/v1/content/company/media/banner/create */
export async function createBanner(
  body: {
    path: string;
    description?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.MediaItem;
    request_id?: string;
  }>('/api/v1/content/company/media/banner/create', {
    method: 'POST',
    data: {
      path: body.path,
      description: body.description,
    },
    ...(options || {}),
  });
}

/** 上传文件接口 POST /api/v1/base/file/upload */
export async function uploadFile(
  file: File,
  options?: { [key: string]: any },
) {
  const formData = new FormData();
  formData.append('file', file);

  return request<{
    success: boolean;
    code: number;
    message: string;
    data: {
      path: string;
      url: string;
    };
    request_id?: string;
  }>('/api/v1/base/file/upload', {
    method: 'POST',
    data: formData,
    requestType: 'form',
    ...(options || {}),
  });
}

/** 更新媒体文件接口 POST /api/v1/content/company/media/${mediaId}/update */
export async function updateMedia(
  mediaId: string,
  body: {
    path?: string;
    description?: string;
    cover?: string;
    is_active?: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.MediaItem;
    request_id?: string;
  }>(`/api/v1/content/company/media/${mediaId}/update`, {
    method: 'POST',
    data: {
      path: body.path,
      description: body.description,
      cover: body.cover,
      is_active: body.is_active,
    },
    ...(options || {}),
  });
}

/** 删除媒体文件接口 POST /api/v1/content/company/media/${mediaId}/delete */
export async function deleteMedia(
  mediaId: string,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.MediaItem;
    request_id?: string;
  }>(`/api/v1/content/company/media/${mediaId}/delete`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取产品列表接口 GET /api/v1/content/product/admin/list */
export async function getProductList(
  params: API.ProductListParams,
  options?: { [key: string]: any },
) {
  return request<API.ProductListResult>('/api/v1/content/product/admin/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建产品接口 POST /api/v1/content/product/create */
export async function createProduct(
  body: {
    name: string;
    description: string;
    introduction: string;
    video?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.ProductItem;
    request_id?: string;
  }>('/api/v1/content/product/create', {
    method: 'POST',
    data: {
      name: body.name,
      description: body.description,
      introduction: body.introduction,
      video: body.video,
    },
    ...(options || {}),
  });
}

/** 更新产品接口 POST /api/v1/content/product/${productId}/update */
export async function updateProduct(
  productId: string,
  body: {
    name?: string;
    description?: string;
    introduction?: string;
    video?: string;
    cover?: string;
    is_active?: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.ProductItem;
    request_id?: string;
  }>(`/api/v1/content/product/${productId}/update`, {
    method: 'POST',
    data: {
      name: body.name,
      description: body.description,
      introduction: body.introduction,
      video: body.video,
      cover: body.cover,
      is_active: body.is_active,
    },
    ...(options || {}),
  });
}

/** 删除产品接口 POST /api/v1/content/product/${productId}/delete */
export async function deleteProduct(
  productId: string,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.ProductItem;
    request_id?: string;
  }>(`/api/v1/content/product/${productId}/delete`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取客户案例列表接口 GET /api/v1/content/case/admin/list */
export async function getCaseList(
  params: API.CaseListParams,
  options?: { [key: string]: any },
) {
  return request<API.CaseListResult>('/api/v1/content/case/admin/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建客户案例接口 POST /api/v1/content/case/create */
export async function createCase(
  body: {
    customer: string;
    title: string;
    introduction: string;
    video: string;
    tag?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.CaseItem;
    request_id?: string;
  }>('/api/v1/content/case/create', {
    method: 'POST',
    data: {
      customer: body.customer,
      title: body.title,
      introduction: body.introduction,
      video: body.video,
      tag: body.tag,
    },
    ...(options || {}),
  });
}

/** 修改客户案例接口 POST /api/v1/content/case/${caseId}/update */
export async function updateCase(
  caseId: string,
  body: {
    customer?: string;
    title?: string;
    introduction?: string;
    video?: string;
    cover?: string;
    tag?: string;
    is_active?: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.CaseItem;
    request_id?: string;
  }>(`/api/v1/content/case/${caseId}/update`, {
    method: 'POST',
    data: Object.fromEntries(
      Object.entries(body).filter(([, value]) => value !== undefined),
    ),
    ...(options || {}),
  });
}

/** 删除客户案例接口 POST /api/v1/content/case/${caseId}/delete */
export async function deleteCase(
  caseId: string,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.CaseItem;
    request_id?: string;
  }>(`/api/v1/content/case/${caseId}/delete`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取客户案例标签选项接口 GET /api/v1/content/case/tags */
export async function getCaseTags(options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: {
      total: number;
      options: Array<{
        label: string;
        value: string;
      }>;
    };
    request_id?: string;
  }>('/api/v1/content/case/tags', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取文章列表接口 GET /api/v1/content/article/admin/list */
export async function getArticleList(
  params: API.ArticleListParams,
  options?: { [key: string]: any },
) {
  return request<API.ArticleListResult>('/api/v1/content/article/admin/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建文章接口 POST /api/v1/content/article/create */
export async function createArticle(
  body: {
    title: string;
    cover?: string;
    introduction?: string;
    link?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.ArticleItem;
    request_id?: string;
  }>('/api/v1/content/article/create', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 修改文章接口 POST /api/v1/content/article/${articleId}/update */
export async function updateArticle(
  articleId: string,
  body: {
    title?: string;
    cover?: string;
    introduction?: string;
    link?: string;
    is_active?: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.ArticleItem;
    request_id?: string;
  }>(`/api/v1/content/article/${articleId}/update`, {
    method: 'POST',
    data: Object.fromEntries(
      Object.entries(body).filter(([, value]) => value !== undefined),
    ),
    ...(options || {}),
  });
}

/** 删除文章接口 POST /api/v1/content/article/${articleId}/delete */
export async function deleteArticle(
  articleId: string,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.ArticleItem;
    request_id?: string;
  }>(`/api/v1/content/article/${articleId}/delete`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 发布文章接口 POST /api/v1/content/article/${articleId}/publish */
export async function publishArticle(
  articleId: string,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.ArticleItem;
    request_id?: string;
  }>(`/api/v1/content/article/${articleId}/publish`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 取消发布文章接口 POST /api/v1/content/article/${articleId}/unpublish */
export async function unpublishArticle(
  articleId: string,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.ArticleItem;
    request_id?: string;
  }>(`/api/v1/content/article/${articleId}/unpublish`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取图集列表接口 GET /api/v1/content/album/admin/list */
export async function getGalleryList(
  params: API.GalleryListParams,
  options?: { [key: string]: any },
) {
  return request<API.GalleryListResult>('/api/v1/content/album/admin/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建图集接口 POST /api/v1/content/album/create */
export async function createGallery(
  body: {
    title: string;
    cover?: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.GalleryItem;
    request_id?: string;
  }>('/api/v1/content/album/create', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 修改图集接口 POST /api/v1/content/album/${galleryId}/update */
export async function updateGallery(
  galleryId: string,
  body: {
    title?: string;
    cover?: string;
    is_active?: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.GalleryItem;
    request_id?: string;
  }>(`/api/v1/content/album/${galleryId}/update`, {
    method: 'POST',
    data: Object.fromEntries(
      Object.entries(body).filter(([, value]) => value !== undefined),
    ),
    ...(options || {}),
  });
}

/** 删除图集接口 POST /api/v1/content/album/${galleryId}/delete */
export async function deleteGallery(
  galleryId: string,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.GalleryItem;
    request_id?: string;
  }>(`/api/v1/content/album/${galleryId}/delete`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取图集图片列表接口 GET /api/v1/content/album/admin/images */
export async function getGalleryImages(
  params: API.GalleryImageListParams,
  options?: { [key: string]: any },
) {
  return request<API.GalleryImageListResult>('/api/v1/content/album/admin/images', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 批量上传图集图片接口 POST /api/v1/content/album/${albumId}/batch-upload */
export async function batchUploadGalleryImages(
  albumId: string,
  files: File[],
  options?: { [key: string]: any },
) {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('files', file);
  });

  return request<{
    success: boolean;
    code: number;
    message: string;
    data: {
      total: number;
      success: number;
      failure: number;
      results: Array<{
        path: string;
      }>;
    };
    request_id?: string;
  }>(`/api/v1/content/album/${albumId}/batch-upload`, {
    method: 'POST',
    data: formData,
    requestType: 'form',
    ...(options || {}),
  });
}

/** 批量删除图集图片接口 POST /api/v1/content/album/batch-delete-images */
export async function batchDeleteGalleryImages(
  imageIds: string[],
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: any;
    request_id?: string;
  }>('/api/v1/content/album/batch-delete-images', {
    method: 'POST',
    data: {
      album_image_ids: imageIds,
    },
    ...(options || {}),
  });
}

/** 获取常见问题列表接口 GET /api/v1/content/question/admin/list */
export async function getFaqList(
  params: API.FaqListParams,
  options?: { [key: string]: any },
) {
  return request<API.FaqListResult>('/api/v1/content/question/admin/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 创建常见问题接口 POST /api/v1/content/question/create */
export async function createFaq(
  body: {
    question: string;
    answer: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.FaqItem;
    request_id?: string;
  }>('/api/v1/content/question/create', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 修改常见问题接口 POST /api/v1/content/question/${questionId}/update */
export async function updateFaq(
  questionId: string,
  body: {
    question?: string;
    answer?: string;
    is_active?: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.FaqItem;
    request_id?: string;
  }>(`/api/v1/content/question/${questionId}/update`, {
    method: 'POST',
    data: Object.fromEntries(
      Object.entries(body).filter(([, value]) => value !== undefined),
    ),
    ...(options || {}),
  });
}

/** 删除常见问题接口 POST /api/v1/content/question/${questionId}/delete */
export async function deleteFaq(
  questionId: string,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.FaqItem;
    request_id?: string;
  }>(`/api/v1/content/question/${questionId}/delete`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取文档标签列表接口 GET /api/v1/content/document/tag/admin/list */
export async function getDocumentTagList(
  params: API.DocumentTagListParams,
  options?: { [key: string]: any },
) {
  return request<API.DocumentTagListResult>('/api/v1/content/document/tag/admin/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取文档标签选项接口 GET /api/v1/content/document/tag/options */
export async function getDocumentTagOptions(options?: { [key: string]: any }) {
  return request<API.DocumentTagOptionsResult>('/api/v1/content/document/tag/options', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 创建文档标签接口 POST /api/v1/content/document/tag/create */
export async function createDocumentTag(
  body: {
    name: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.DocumentTagItem;
    request_id?: string;
  }>('/api/v1/content/document/tag/create', {
    method: 'POST',
    data: {
      name: body.name,
    },
    ...(options || {}),
  });
}

/** 修改文档标签接口 POST /api/v1/content/document/tag/${tagId}/update */
export async function updateDocumentTag(
  tagId: string,
  body: {
    name: string;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.DocumentTagItem;
    request_id?: string;
  }>(`/api/v1/content/document/tag/${tagId}/update`, {
    method: 'POST',
    data: {
      name: body.name,
    },
    ...(options || {}),
  });
}

/** 删除文档标签接口 POST /api/v1/content/document/tag/${tagId}/delete */
export async function deleteDocumentTag(
  tagId: string,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.DocumentTagItem;
    request_id?: string;
  }>(`/api/v1/content/document/tag/${tagId}/delete`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取资料文档列表接口 GET /api/v1/content/document/admin/list */
export async function getDocumentList(
  params: API.DocumentListParams,
  options?: { [key: string]: any },
) {
  return request<API.DocumentListResult>('/api/v1/content/document/admin/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 修改资料文档接口 POST /api/v1/content/document/${documentId}/update */
export async function updateDocument(
  documentId: string,
  body: {
    title?: string;
    path?: string;
    tag_id?: string;
    is_internal?: boolean;
    is_active?: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.DocumentItem;
    request_id?: string;
  }>(`/api/v1/content/document/${documentId}/update`, {
    method: 'POST',
    data: Object.fromEntries(
      Object.entries(body).filter(([, value]) => value !== undefined),
    ),
    ...(options || {}),
  });
}

/** 创建资料文档接口 POST /api/v1/content/document/create */
export async function createDocument(
  body: {
    title: string;
    path: string;
    tag_id?: string;
    is_internal?: boolean;
  },
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.DocumentItem;
    request_id?: string;
  }>('/api/v1/content/document/create', {
    method: 'POST',
    data: {
      title: body.title,
      path: body.path,
      tag_id: body.tag_id,
      is_internal: body.is_internal,
    },
    ...(options || {}),
  });
}

/** 删除资料文档接口 POST /api/v1/content/document/${documentId}/delete */
export async function deleteDocument(
  documentId: string,
  options?: { [key: string]: any },
) {
  return request<{
    success: boolean;
    code: number;
    message: string;
    data: API.DocumentItem;
    request_id?: string;
  }>(`/api/v1/content/document/${documentId}/delete`, {
    method: 'POST',
    ...(options || {}),
  });
}
